<template>
    <div class="tgp-item">
        <a rel="nofollow" :class="[linkClass]" :href="link">
            <video v-if="isVideo" class="tgp-item-content lazy" preload="auto" loop autoplay playsinline muted :data-src="nativeUrl"></video>
            <picture v-else>
                <source type="image/webp" :data-srcset="webpUrl">
                <img class="tgp-item-content lazy" :data-src="nativeUrl" :alt="item.alt" />
            </picture>
            <div v-if="isVideo && item.showOverlay" class="tgp-link-video-overlay">
              <span class="tgp-link-video-icon"></span>
            </div>
        </a>
    </div>
</template>

<script>
export default {
    name: "TgpItem",
    props: {
        item: {type: Object, required: true},
        urlConfig: {type: Object, required: true},
    },

    computed: {
        isVideo() {
            return /\.mp4/.test(this.item.url.native);
        },

        linkClass() {
            return this.isVideo ? 'tgp-link-video' : 'tgp-link-image';
        },

        webpUrl() {
            return this.encode(this.item.url.webp);
        },

        nativeUrl() {
            return this.encode(this.item.url.native);
        },

        link() {
            let {joinUrl, carryOverUrl, defaultCarryOver} = this.urlConfig;

            const carryOver = this.item.movie_id ? `movie.${this.item.movie_id}` : defaultCarryOver;
            if (carryOverUrl && carryOver) {
                return carryOverUrl + '?return_url=' + encodeURIComponent(joinUrl) + '&carry=' + encodeURIComponent(carryOver + '.external');
            }

            return joinUrl;
        },
    },

    methods: {
        encode(url) {
            return encodeURI(url).replace('!', '%21');
        },
    },
}
</script>

<style>
    .tgp-item {
        position: relative;
        margin-bottom: 4px;
    }

    .tgp-item .lazy {
        padding-top: 100%;
        height: 0;
    }

    .tgp-item .lazy.loaded {
        padding-top: 0;
        height: auto;
    }

    .tgp-item-content {
        width: 100%;
        display: block;
    }

    .tgp-tower-aspect-ratio .tgp-link-image {
        display: block;
        position: relative;
        padding-top: 168.7467%; /* smaller aspect ratio for the compact layout */
    }

    .tgp-tower-aspect-ratio .tgp-link-image {
        padding-top: 169.8%; /* smaller aspect ratio for the 4px grid space */
    }

    .gutters .tgp-tower-aspect-ratio .tgp-link-image {
        padding-top: 174.7252%; /* 91 : 159 aspect ratio */
    }

    .tgp-tower-aspect-ratio .tgp-item-content {
        position: absolute;
        top: 0;
        width: 100%;
        height: 100% !important;
        object-fit: cover;
    }

    .tgp-item-content {
        position: relative;
        z-index: 5;
    }

    .tgp-link-video-overlay {
        display: none;
        position: absolute;
        top: 0; right: 0; bottom: 0; left: 0;
        z-index: 10;
        background: rgba(0, 0, 0, .45);
    }

    .tgp-link-video-icon {
        position: absolute;
        top: 50%;
        left: 50%;
        margin: -53px 0 0 -53px;
        width: 106px;
        height: 106px;
        background-image: url(data:image/svg+xml;charset=utf-8,%3Csvg%20version%3D%221.1%22%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%20viewBox%3D%220%200%20140%20140%22%20style%3D%22%22%20xml%3Aspace%3D%22preserve%22%20height%3D%22100%25%22%20width%3D%22100%25%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bopacity%3A0.6%3Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3Bfill%3A%23FFFFFF%3B%7D%0A%09.st1%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3Bfill%3A%23FFFFFF%3B%7D%0A%3C%2Fstyle%3E%0A%3Cpath%20class%3D%22st0%22%20d%3D%22M70%2C5C34.1%2C5%2C5%2C34.1%2C5%2C70s29.1%2C65%2C65%2C65c35.9%2C0%2C65-29.1%2C65-65S105.9%2C5%2C70%2C5z%20M70%2C132c-34.2%2C0-62-27.8-62-62%0A%09S35.8%2C8%2C70%2C8c34.2%2C0%2C62%2C27.8%2C62%2C62S104.2%2C132%2C70%2C132z%22%2F%3E%0A%3Cg%20id%3D%22Shape_2_copy%22%3E%0A%09%3Cg%3E%0A%09%09%3Cpath%20class%3D%22st1%22%20d%3D%22M89.2%2C68.5L63.1%2C50.4c-0.6-0.4-1.4-0.5-2-0.1c-0.6%2C0.3-1.1%2C1-1.1%2C1.7v36.2c0%2C0.7%2C0.4%2C1.4%2C1.1%2C1.7%0A%09%09%09c0.3%2C0.1%2C0.6%2C0.2%2C0.9%2C0.2c0.4%2C0%2C0.8-0.1%2C1.1-0.4l26.1-18.1c0.5-0.4%2C0.8-0.9%2C0.8-1.5C90%2C69.4%2C89.7%2C68.8%2C89.2%2C68.5z%20M63.9%2C84.4V55.6%0A%09%09%09L84.7%2C70L63.9%2C84.4z%22%2F%3E%0A%09%3C%2Fg%3E%0A%3C%2Fg%3E%0A%3C%2Fsvg%3E);
        background-position: center center;
        background-repeat: no-repeat;
    }

    .tgp-link-video:hover .tgp-link-video-overlay {
        display: block;
    }

    .tgp-link-video:hover .tgp-link-video-icon {
        -webkit-animation: playInAndOut 3s linear 0s infinite;
        animation: playInAndOut 3s linear 0s infinite;
    }

    @-webkit-keyframes playInAndOut {
        0% {transform: scale(1)}
        25% {transform: scale(1.15)}
        50% {transform: scale(1)}
        100% {transform: scale(1)}
    }

    @keyframes playInAndOut {
        0% {transform: scale(1)}
        25% {transform: scale(1.15)}
        50% {transform: scale(1)}
        100% {transform: scale(1)}
    }

    @media (min-width: 768px) {
        .gutters .tgp-item {
            margin-top: 10px;
        }
    }

    @media (min-width: 1024px) {
        .gutters .tgp-item {
            margin-top: 20px;
        }
    }
</style>
